import { Component, OnInit } from "@angular/core";
declare var $: any;
@Component({
  selector: "cmp-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    $(".loader-item").delay(400).fadeOut();
    $("#pageloader").delay(500).fadeOut("slow");
  }
  title = "CRDA-CustomerPortal";
}
